exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cxWait {\n  color: #777;\n  font-style: italic;\n  font-size: 1em;\n}\n.cxWait-block {\n  display: block;\n  text-align: center;\n  font-size: 2rem;\n  color: #bbbbbb;\n  background-color: #f1f1f1;\n  padding: 1rem;\n  margin-bottom: 0.5rem;\n}\n.cxWait-progress {\n  margin-top: 1rem;\n}\n.cxWait-progress p {\n  font-size: 1.5rem;\n  text-align: left;\n  margin: 0;\n  padding: 0;\n}\n.cxWait-full {\n  display: block;\n  text-align: center;\n  font-size: 3rem;\n  color: #c9c9c9;\n  background-color: #f1f1f1;\n  padding: 2rem;\n  margin: 2rem 0;\n}\n.cxWait-full .cxWait-text {\n  display: block;\n}\n.cxWait-full .cxWait-progress {\n  margin: 2rem auto;\n  max-width: 50vw;\n}\n.cxWait-full .cxWait-progress p {\n  font-size: 2rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/wait/waitUntil.directive.less
// module id = 1483
// module chunks = 2